import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { DividerModule } from '../divider/divider.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalSearchFiltersComponent } from './global-search-filters.component';
import { SidePanelModule } from '../side-panel/side-panel.module';
import { SearchResultModalComponent } from './components/search-modal/search-modal.component';
import { SearchBarAndResultComponent } from './components/search-bar-and-result/search-bar-and-result.component';
import { GlobalSearchFiltersService } from './services/global-search-filters.service';
import { GlobalSearchFiltersServiceConfig } from './services/global-search-filters.service.config';
import { TabModule } from './../../shared-ui-refresh/tab/tab.module';
import { HighlightTextPipe } from './pipes/highlightText.pipe';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ResultListComponent } from './components/result-list/result-list.component'
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

@NgModule({
    imports: [
        FormsModule,
        DividerModule,
        TranslateModule.forChild({
            loader: provideTranslateHttpLoader({ prefix: "./assets/i18n/", suffix: '.json?v=' + Date.now() }),

        }),
        ReactiveFormsModule,
        CommonModule,
        SidePanelModule,
        TabModule
    ],
    declarations: [
        GlobalSearchFiltersComponent,
        SearchResultModalComponent,
        ResultListComponent,
        SearchBarAndResultComponent,
        HighlightTextPipe
    ],
    exports: [
        GlobalSearchFiltersComponent,
        SearchResultModalComponent,
        ResultListComponent,
        SearchBarAndResultComponent
    ],
    providers: [
        GlobalSearchFiltersServiceConfig,
        GlobalSearchFiltersService
    ]
})

export class GlobalSearchFiltersModule { }
